import { observer } from 'mobx-react-lite'
import { Dropdown, type IDropdownProps, SearchElement } from 'shared/ui'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { SearchTypesEnum } from 'widgets/SearchDropdown'
import { TimeRangeDropdownContent } from 'widgets/SearchDropdown/ui/DropdownContent/TimeRangeDropdownContent/TimeRangeDropdownContent'
import { type SearchDropdownTimeRangeStore } from 'widgets/SearchDropdown/store/searchDropdownTimeRangeStore'

type TimeRangeElementProps = {
  parentsDropdownId?: string[]
  store: SearchDropdownTimeRangeStore
  onRemove: (type: SearchTypesEnum) => void
  activeType: SearchTypesEnum | null
  canShowChildDropdown: boolean
  dropdownProps?: Partial<IDropdownProps>
}

export const TimeRangeElement = observer(
  ({
    parentsDropdownId,
    store,
    onRemove,
    activeType,
    canShowChildDropdown,
    dropdownProps,
  }: TimeRangeElementProps) => {
    const { hasSelectedItems, fromTime, toTime, disableClosing } = store

    const formatTime = (time: Date | null) => {
      if (!time) return ''
      return uiStore.dayjsWithoutTimezone(time).format(DayjsFormats.time2)
    }

    const title = () => {
      if (fromTime && toTime) {
        return `${formatTime(fromTime)} - ${formatTime(toTime)}`
      }
      return ''
    }

    return (
      <Dropdown
        ariaLabel={'TimeElement'}
        parentsDropdownId={parentsDropdownId}
        iconButtonProps={{
          size: 'medium',
          fontSize: 20,
          ariaLabel: 'TimeElement_trigger',
        }}
        show={activeType === SearchTypesEnum.time_range && canShowChildDropdown}
        triggerComponent={(open) => (
          <SearchElement
            icon={'clock'}
            type='Time'
            removeCallback={() => {
              onRemove(SearchTypesEnum.time_range)
            }}
            content={hasSelectedItems && title()}
            warningContent={!open && !hasSelectedItems}
            contentDefaultValue={'select'}
            isViewOnly={disableClosing}
          />
        )}
        placement={'bottom-start'}
        sizeTriggerButton={'medium'}
        variantTriggerButton={'icon'}
        customComponent={(onCloseMenu, dropdownId) => (
          <TimeRangeDropdownContent
            store={store}
            onCloseMenu={onCloseMenu}
            parentsDropdownId={
              parentsDropdownId ? [...parentsDropdownId, dropdownId] : [dropdownId]
            }
          />
        )}
        {...dropdownProps}
      />
    )
  }
)
